import { jsx as _jsx } from "react/jsx-runtime";
export const CrossCircleS = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM14.4697 8.46973C14.7626 8.17683 15.2374 8.17683 15.5303 8.46973C15.8232 8.76262 15.8232 9.23738 15.5303 9.53027L13.0605 12L15.582 14.5264C15.8223 14.8209 15.8049 15.2557 15.5303 15.5303C15.2557 15.8049 14.8209 15.8223 14.5264 15.582L12 13.0605L9.53027 15.5303C9.23738 15.8232 8.76262 15.8232 8.46973 15.5303C8.17683 15.2374 8.17683 14.7626 8.46973 14.4697L10.9395 12L8.41797 9.47363C8.17766 9.17905 8.19512 8.74433 8.46973 8.46973C8.74433 8.19512 9.17905 8.17766 9.47363 8.41797L12 10.9395L14.4697 8.46973Z",
            fill: color
        })
    });

//# sourceMappingURL=cross-circle-s.js.map